import { Link } from "react-router-dom";
import { Copy, ArrowRight } from "@phosphor-icons/react";

export default function PublicHeader({ user, copying, onCopy }) {
  return (
    <header className="border-b border-border bg-card/80 backdrop-blur-xl">
      <div className="max-w-5xl mx-auto px-6 py-4 flex justify-between items-center">
        <Link to="/" className="flex items-center gap-3" data-testid="public-brand">
          <div className="w-9 h-9 grid place-items-center bg-volt text-black font-display font-black text-base">TP</div>
          <div className="leading-none">
            <div className="font-display text-2xl font-black tracking-tight">TACTICAL</div>
            <div className="label-mono">PROGRESSION</div>
          </div>
        </Link>
        <div className="flex gap-2">
          {!user && <Link to="/login" className="border border-border px-4 py-2 uppercase text-xs tracking-widest hover:border-volt hover:text-volt">Login</Link>}
          <button onClick={onCopy} disabled={copying} className="bg-volt text-black px-4 py-2 font-display uppercase tracking-widest text-sm hover:bg-white disabled:opacity-50 inline-flex items-center gap-2" data-testid="public-copy-btn">
            <Copy size={14} weight="bold" /> {copying ? "Copying..." : (user ? "Copy to My Plans" : "Sign Up & Copy")} <ArrowRight size={14} weight="bold" />
          </button>
        </div>
      </div>
    </header>
  );
}
